import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kuajingkongpaifuwu",
  "use": "icon-kuajingkongpaifuwu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-kuajingkongpaifuwu\"><path d=\"M1 12h14v1H1v-1zm13.963-5.275c-.15-.5-.713-.8-1.275-.662l-3.463.825a.468.468 0 01-.387-.063L3.963 3.012a.278.278 0 00-.2-.037l-.8.188c-.188.05-.263.275-.126.412l3.338 3.5a.497.497 0 01-.25.825l-2.35.6a.5.5 0 01-.4-.075l-1.087-.763a.29.29 0 00-.2-.037l-.55.138c-.163.037-.25.237-.15.374L2.25 9.8l.337.525a.499.499 0 00.538.213l.763-.188 3.662-.875 3-.725 3.662-.875c.575-.138.9-.65.75-1.15z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/kuajingkongpaifuwu.svg
// module id = 492
// module chunks = 4